export const orgDiaryTranslations = {
  lv: {
    title: 'Vērtēšana',
    description:
      'Jūsu praktikantu dienasgrāmatas ieraksti. Vērtēt un komentēt varat tikai ierakstus, kuru plāna punktā esat norādīts kā vērtētājs.',
    waiting: 'Gaida manu vērtējumu',
    all: 'Visi manu praktikantu ieraksti',
    count: '{{count}} gaida jūsu vērtējumu',
    date: 'Datums',
    intern: 'Praktikants',
    programitem: 'Plāna punkts',
    org: 'Izglītības iestāde',
    time: 'Laiks',
    academichours: 'Stundas',
    grade: 'Vērtējums',
    commentIntern: 'Praktikanta komentārs',
    commentSupervisor: 'Prakses vietas komentārs',
    commentEduSupervisor: 'Izglītības iestādes komentārs',
    internship: 'Prakse',
    comment: 'Komentārs',
    save: 'Saglabāt',
    saved: 'Ieraksts saglabāts',
    failed: 'Neizdevās saglabāt ierakstu. Mēģiniet vēlreiz.',
    loadError: 'Neizdevās ielādēt dienasgrāmatas ierakstus.',
    empty: 'Nav ierakstu',
    emptyWaiting: 'Visi jums piešķirtie ieraksti ir novērtēti.',
    emptyFiltered: 'Izvēlētajiem filtriem nav atbilstošu ierakstu.',
    credited: 'Ieskaitīts',
    notCredited: 'Neieskaitīts',
    delete: 'Dzēst ierakstu',
    deleteConfirm: 'Vai dzēst šo dienasgrāmatas ierakstu? Šo darbību nevar atsaukt.',
    deleteFailed: 'Neizdevās dzēst ierakstu. Mēģiniet vēlreiz.',
    actions: 'Darbības',
    edit: 'Vērtēt / komentēt',
    waitingStatus: 'Bez vērtējuma',
  },
  en: {
    title: 'Grading',
    description:
      'Your interns’ diary entries. You can grade and comment only on entries whose plan item assigns you as the grader.',
    waiting: 'Waiting for my grade',
    all: 'All my interns’ entries',
    count: '{{count}} waiting for your grade',
    date: 'Date',
    intern: 'Intern',
    programitem: 'Plan item',
    org: 'Educational institution',
    time: 'Time',
    academichours: 'Hours',
    grade: 'Grade',
    commentIntern: 'Intern’s comment',
    commentSupervisor: 'Workplace comment',
    commentEduSupervisor: 'Educational institution comment',
    internship: 'Internship',
    comment: 'Comment',
    save: 'Save',
    saved: 'Entry saved',
    failed: 'Could not save the entry. Try again.',
    loadError: 'Could not load diary entries.',
    empty: 'No entries',
    emptyWaiting: 'All entries assigned to you have been graded.',
    emptyFiltered: 'No entries match these filters.',
    credited: 'Credited',
    notCredited: 'Not credited',
    delete: 'Delete entry',
    deleteConfirm: 'Delete this diary entry? This cannot be undone.',
    deleteFailed: 'Could not delete the entry. Try again.',
    actions: 'Actions',
    edit: 'Grade / comment',
    waitingStatus: 'Ungraded',
  },
}

export const eduDiaryTranslations = {
  lv: {
    org: 'Prakses vieta',
    description:
      'Dienasgrāmatas ieraksti, kuru plāna punktā vērtētājs ir izglītības iestāde. Pārējos vērtē prakses vieta. Redzat tikai savu praktikantu ierakstus.',
  },
  en: {
    org: 'Workplace',
    description:
      'Your interns’ diary entries. You can grade and comment only on entries whose plan item assigns you as the educational institution grader.',
  },
}
